import { Search } from "lucide-react";

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  className = "",
  ariaLabel,
}) {
  return (
    <div className={`relative max-w-[340px] flex-1 ${className}`.trim()}>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute left-[14px] top-1/2 -translate-y-1/2 text-(--text-muted)"
      >
        <Search size={16} strokeWidth={1.8} />
      </span>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className="w-full rounded-(--radius-md) border border-(--border-strong) bg-(--surface-1) py-[10px] pl-[38px] pr-[14px] text-[13px] text-(--text-primary) placeholder:text-(--text-muted) focus:border-(--brand-primary) focus:outline-none focus:ring-2 focus:ring-(--brand-primary)/20"
      />
    </div>
  );
}
